import {
  GET_STRIPE_SUBSCRIPTION_PLANS_SUCCESS,
  GET_STRIPE_SUBSCRIPTION_PLANS_FAIL,
} from "../actionTypes";

const initialState = {
  subData: null,
};

const stripeSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STRIPE_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        subData: action.payload.subData,
      };
    case GET_STRIPE_SUBSCRIPTION_PLANS_FAIL:
      return {
        ...state,
        subData: null,
      };
    default:
      break;
  }
  return state;
};

export default stripeSubscriptionReducer;
